import { useState } from "react";
import { Input } from "@/components/ui/input";
import { useLang } from "@/lib/i18n";
import { Field } from "@/components/xd/ui";

export const splitName = (u) => {
  if (u?.first_name || u?.last_name) return [u.first_name || "", u.last_name || ""];
  const parts = (u?.name || "").trim().split(/\s+/).filter(Boolean);
  return [parts[0] || "", parts.slice(1).join(" ")];
};

export const NameForm = ({ user, onSave, testid = "name-form" }) => {
  const { t } = useLang();
  const [first0, last0] = splitName(user);
  const [first, setFirst] = useState(first0);
  const [last, setLast] = useState(last0);
  const [busy, setBusy] = useState(false);
  const ok = first.trim().length >= 2 && last.trim().length >= 2;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onSave({ first_name: first.trim(), last_name: last.trim() }); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid={testid}>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label={t("form.first_name")}><Input required minLength={2} maxLength={40} className="xd-input" value={first} onChange={(e) => setFirst(e.target.value)} data-testid={`${testid}-first`} /></Field>
        <Field label={t("form.last_name")}><Input required minLength={2} maxLength={40} className="xd-input" value={last} onChange={(e) => setLast(e.target.value)} data-testid={`${testid}-last`} /></Field>
      </div>
      <button className="btn-xd w-full sm:w-auto justify-center" disabled={!ok || busy} data-testid={`${testid}-save`}>{t("common.save")}</button>
    </form>
  );
};
